import type { ComponentProps } from 'react';

import InstitutionVerification from '@/features/institution/verification/components';

type InstitutionVerificationPageProps = ComponentProps<typeof InstitutionVerification>;

const InstitutionVerificationPage = (props: InstitutionVerificationPageProps) => {
  return <InstitutionVerification {...props} />;
};
InstitutionVerificationPage.displayName = 'InstitutionVerificationPage';

export default InstitutionVerificationPage;
